<template>
  <div class="fit-content">
    <div style="display: flex">
      <div v-for="(item, index) in upElementBlocks" :key="index" class="section form-column" :style="{width: item.width + 'px'}">
        <el-form :disabled="disabled" label-position="right" label-width="120px">
          <span class="title">{{ item.title }}</span>
          <template v-for="elementName in item.elementNames">
            <slot :name="elementName" />
            <template v-if="elementName === 'jobNo'">
              <slot name="saleProductCode" />
              <slot name="fullOrInside" />
            </template>
          </template>
        </el-form>
      </div>
    </div>
    <div v-if="downElementBlock && downElementBlock.name === 'cargoInfo'" style="flex-direction: column">
      <div class="section">
        <el-form :disabled="disabled" label-position="right" label-width="120px">
          <span class="title">{{ downElementBlock.title }}</span>
          <div style="width: 1100px;display: flex;flex-wrap: wrap">
            <slot name="goodsInfo" />
            <template v-for="(elementName, index) in downElementBlock.elementNames">
              <template v-if="lineBreak.hasOwnProperty(elementName) && lineBreak[elementName]">
                <div :key="index" style="width: 100%;" />
              </template>
              <slot :name="elementName" />
            </template>
          </div>
        </el-form>
      </div>
    </div>
    <div v-if="downElementBlock && downElementBlock.name === 'CargoInformation'" style="flex-direction: column">
      <div class="section">
        <el-form :disabled="disabled" label-position="right" label-width="120px">
          <span class="title">{{ downElementBlock.title }}</span>
          <div style="width: 1100px;display: flex;flex-wrap: wrap">
            <template v-for="(elementName, index) in downElementBlock.elementNames">
              <template v-if="lineBreak.hasOwnProperty(elementName) && lineBreak[elementName]">
                <div :key="index" style="width: 100%;" />
              </template>
              <slot :name="elementName" />
            </template>
          </div>
        </el-form>
      </div>
    </div>
    <slot name="ticketsInfo" />
  </div>
</template>

<script>
export default {
  name: 'TabGeneralUICustomLayout',
  props: {
    elementBlocks: { type: Array, required: true },
    elementDict: { type: Object, required: true },
    disabled: { type: Boolean, default: false }
  },
  data() {
    return {
      lineBreak: {
        cargoChineseName: false,
        cargoEnglishName: false,
        mark: false
      }
    }
  },
  computed: {
    upElementBlocks() {
      return this.elementBlocks.filter(p => p.position === 1 && !p.hide)
    },
    downElementBlock() {
      return this.elementBlocks.find(p => p.position === 2 && !p.hide)
    }
  },
  watch: {
    elementBlocks() {
      this.init()
    },
    elementDict() {
      this.init()
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      const lineBreak = this.lineBreak
      lineBreak.cargoChineseName = false
      lineBreak.cargoEnglishName = false
      lineBreak.mark = false
      const cargoInfo = this.elementBlocks.find(p => p.position === 2 && !p.hide && p.name === 'cargoInfo')
      if (cargoInfo) {
        let isNewLine = true
        for (let i = 0; i < cargoInfo.elementNames.length; ++i) {
          const elementName = cargoInfo.elementNames[i]
          if (this.elementDict[elementName]) {
            if (lineBreak.hasOwnProperty(elementName)) {
              lineBreak[elementName] = isNewLine
              isNewLine = false
            } else {
              isNewLine = true
            }
          }
        }
      }
    }
  }
}
</script>
